const groupBy = <T, K extends string | number | symbol>(items: T[], key: (item: T) => K): Record<K, T[]> => {
  const result = {} as Record<K, T[]>;

  for (const item of items) {
    const groupKey = key(item);
    if (result[groupKey]) {
      result[groupKey].push(item);
    } else {
      result[groupKey] = [item];
    }
  }

  return result;
};

export default groupBy;
